<div *ngFor="let item of blockAreaQuienes_items">
    <div class="row">
        <div class="col-lg-12" data-aos="zoom-in-up" data-aos-duration="1500">
            <div class="tit-stroke">
                <h1 class="vlt-stroke-text preline_title">{{item.title}}</h1>

                    <div class="vlt-stroke-num">{{item.titleNum}}</div>

            </div>
        </div>   
    </div>

    <div class="row">
        <div class="col-lg-8 col-md-12" data-aos="zoom-in-up" data-aos-duration="1500">    
            <p class="light" [innerHTML]="item.mainText1"></p>
        </div>   
    </div>
</div>